
import { ReactComponent as Sweden } from "../assets/sweden.svg"

import MapPin from "./MapPin";





const Map = (props) => {

  const mapPins = [
    { id: 1, top: "68%", right: "45%", name: "Stockholm", description: ["Östermalmsgatan 26A", "114 26"], maps: "https://maps.app.goo.gl/JyhzREq5PABrRaZC9" }, // Stockholm
    { id: 2, top: "66%", right: "52%", name: "Västerås", description: ["Tallmätargatan 1", "721 34"], maps: "https://maps.app.goo.gl/hPpMDsCqvru7k7aM6" }, // Västerås
    { id: 3, top: "61%", right: "59%", name: "Falun", description: ["Sturegatan 87", "791 60"], maps: "https://maps.app.goo.gl/BCnFEFJ8LLyMsw9q9" }, // Falun
  ];

  return (
    <div className="relative w-full flex justify-center">
      <div>
        <Sweden className="h-[600px] sm:h-[800px] text-slate-400 dark:text-slate-700" />
      </div>
      {mapPins.map((pin) => (
        <MapPin
          key={pin.id}
          top={pin.top}
          right={pin.right}
          name={pin.name}
          description={pin.description}
          maps={pin.maps}
        />
      ))}
    </div>

  );
};

export default Map;